import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import nb from './locales/nb.json';
import en from './locales/en.json';
import sv from './locales/sv.json';
import da from './locales/da.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { nb: { translation: nb }, en: { translation: en }, sv: { translation: sv }, da: { translation: da } },
    fallbackLng: 'en',
    supportedLngs: ['nb', 'en', 'sv', 'da'],
    interpolation: { escapeValue: false },
    detection: { order: ['localStorage', 'navigator'], caches: ['localStorage'] },
  });

// Currency helpers
export const CURRENCIES = {
  NOK: { symbol: 'kr', locale: 'nb-NO' },
  SEK: { symbol: 'kr', locale: 'sv-SE' },
  EUR: { symbol: '€', locale: 'de-DE' },
  GBP: { symbol: '£', locale: 'en-GB' },
  USD: { symbol: '$', locale: 'en-US' },
};

export const DEFAULT_CURRENCY_BY_LANG = { nb: 'NOK', sv: 'SEK', da: 'EUR', en: 'EUR' };

// NOTE: our pricing tiers are priced in EUR natively. Convert to user currency for display.
export function formatPrice(eurAmount, currencyCode = 'EUR') {
  const cur = CURRENCIES[currencyCode] || CURRENCIES.EUR;
  const inverseRates = { NOK: 11.6, SEK: 11.4, EUR: 1, GBP: 0.86, USD: 1.09 };
  const amount = eurAmount * (inverseRates[currencyCode] || 1);
  return `${cur.symbol}${Math.round(amount).toLocaleString(cur.locale)}`;
}

export default i18n;
